<template>
  <div
    class="fontawesome-picker w-full relative border border-solid border-grey-700 bg-grey-800 rounded-lg"
  >
    <input
      ref="input"
      class="fontawesome-picker__input w-full h-10 outline-none rounded-lg px-4 text-sm text-white bg-grey-800"
      type="text"
      placeholder="Search icon"
      :value="iconClassName"
      @click="showPicker"
      @input="updateInput"
    />
    <div
      v-show="picker"
      class="fontawesome-picker__picker flex flex-wrap overflow-x-hidden p-2 border-t border-grey-700"
    >
      <span
        v-for="(icon, idx) in displayList"
        :key="idx"
        class="fontawesome-picker__icon inline-flex justify-center items-center w-8 h-8 cursor-pointer rounded shadow-md text-white hover:bg-primary"
        :class="{
          'fontawesome-picker__icon--selected bg-primary':
            appIcon.length &&
            appIcon[0] === icon.prefix &&
            appIcon[1] === icon.iconName
        }"
        @click="closePicker(icon);"
      >
        <font-awesome-icon
          :icon="[icon.prefix, icon.iconName]"
          :title="icon.iconName"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { debounce } from 'lodash';

delete fas.faFontAwesomeLogoFull;
delete far.faFontAwesomeLogoFull;
delete fab.faFontAwesomeLogoFull;

library.add(fas, far, fab);

const icons = [
  ...Object.values(fas),
  ...Object.values(far),
  ...Object.values(fab)
];

export default {
  name: 'FontAwesomePicker',
  components: {
    FontAwesomeIcon
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      picker: true,
      icons: Object.freeze(icons),
      appIcon: [],
      iconClassName: '',
    };
  },
  computed: {
    displayList() {
      if (!this.iconClassName.length) return [];
      return this.icons.filter(
        x =>
          !this.iconClassName || `${x.prefix} fa-${x.iconName}`.includes(this.iconClassName)
      );
    }
  },
  mounted() {
    let [prefix, iconName] = this.value.split(' ');
    if (iconName) iconName = iconName.slice('fa-'.length);
    this.setValue({ prefix, iconName });
  },
  methods: {
    setValue(icon) {
      this.appIcon = [icon.prefix, icon.iconName];
      this.iconClassName = `${icon.prefix} fa-${icon.iconName}`;
    },
    showPicker() {
      this.picker = true;
    },

    updateInput: debounce(function() {
      this.iconClassName = this.$refs.input.value;
      this.$emit('input', this.iconClassName);
    }, 700),

    closePicker(icon) {
      this.setValue(icon);
      this.$emit('change', this.iconClassName);
    }
  }
};
</script>

<style lang="scss">
.fontawesome-picker__picker {
  min-height: 50px;
  max-height: 200px;
}

.fontawesome-picker__icon {
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
}
</style>
